import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/accessibility-theme.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { LanguageProvider, UserProvider } from "./utils";
import { TranslationProvider } from "./context/TranslationContext";
import { AccessibilityProvider } from "./accessibility";
import "./styles/high-contrast.css";
import "./styles/black-white.css";
import "./styles/reduce-motion.css";
import "./styles/reduce-transparency.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <TranslationProvider>
      <LanguageProvider>
        <UserProvider>
          <AccessibilityProvider>
            <App />
          </AccessibilityProvider>
        </UserProvider>
      </LanguageProvider>
    </TranslationProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
